import React from 'react';

const SvgTrashBin = props => (
  <svg width={12} height={14} {...props}>
    <path
      d="M7.333.5a1 1 0 011 1v.333H10a1 1 0 01.333 1.943v7.962c0 .79-.597 1.429-1.333 1.429H3c-.736 0-1.333-.64-1.333-1.429V3.776A1 1 0 012 1.833h1.666V1.5a1 1 0 011-1h2.667zm2.334 3.333H2.333v7.945c0 .399.299.722.667.722h6c.368 0 .667-.323.667-.722V3.833zM4 5.167c.184 0 .333.149.333.333v5.333a.333.333 0 11-.666 0V5.5c0-.184.149-.333.333-.333zm2 0c.184 0 .333.149.333.333v5.333a.333.333 0 11-.666 0V5.5c0-.184.149-.333.333-.333zm2 0c.184 0 .333.149.333.333v5.333a.333.333 0 11-.666 0V5.5c0-.184.149-.333.333-.333zM10 2.5H8.276v.001H3.724l-.001-.002L2 2.5a.333.333 0 000 .667h8a.333.333 0 000-.667zM7.333 1.167H4.667a.333.333 0 00-.334.333v.333h3.333V1.5a.333.333 0 00-.333-.333z"
      fill="#046FE2"
      fillRule="nonzero"
      stroke="#046fe2"
      strokeWidth="0.2"
    />
  </svg>
);

export default SvgTrashBin;
